import { Injectable, WritableSignal, signal } from '@angular/core';
import { UserDb } from '../cosmos/user/userDb.js';
import { jwtDecode } from 'jwt-decode';
import { CookieService } from 'lib/cookies/cookie.service.js';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	private readonly authCookieExpiresInDays: number = 365;
	public readonly authUser: WritableSignal<UserDb.IAuthUser | undefined>;

	constructor(private cookieService: CookieService) {
		const authUser = this.initAuthUser();
		this.authUser = signal(authUser);
	}

	login(accessToken: string): void {
		this.cookieService.setCookie('Token', accessToken, this.authCookieExpiresInDays);
		this.authUser.set(this.mapAccessTokenToAuthUser(accessToken));
	}

	logout(): void {
		this.removeAccessToken();
		this.authUser.set(undefined);
	}

	getAccessToken(): string | undefined {
		return this.cookieService.getCookie('Token');
	}

	updateAuthUser(accessToken: string): UserDb.IAuthUser | undefined {
		const authUser = this.mapAccessTokenToAuthUser(accessToken);
		this.authUser.set(authUser);
		this.cookieService.setCookie('Token', accessToken, this.authCookieExpiresInDays);
		return authUser;
	}

	isAuthenticated(): boolean {
		return this.getAccessToken()?.length ? true : false;
	}

	private initAuthUser(): UserDb.IAuthUser | undefined {
		const accessToken = this.getAccessToken();
		return this.mapAccessTokenToAuthUser(accessToken);
	}

	private removeAccessToken(): void {
		this.cookieService.deleteCookie('Token');
	}

	private mapAccessTokenToAuthUser(accessToken: string | undefined): UserDb.IAuthUser | undefined {
		if (!accessToken) {
			return undefined;
		}

		const decodedToken = jwtDecode<UserDb.IAuthUser>(accessToken, {});

		if (!decodedToken) {
			return undefined;
		}

		return decodedToken;
	}
}
